<section id="cta-final" class="section final-cta">
	<div class="container cta-box">
		<h2>Da el salto a una gestión más ordenada, clara y profesional</h2>
		<p>
			Activá tu prueba, centralizá clientes, tareas, presupuestos, cobros, reparaciones, seguimiento y empezá a
			trabajar con una visión más completa de tu negocio desde el primer día.
		</p>
		<div class="hero-cta">
			<a class="btn btn-ghost" href="#planes">Comparar planes</a>
		</div>

		<div class="contact-form-wrap">
			<form #contactForm="ngForm" class="contact-form" (ngSubmit)="submitContact(contactForm)" novalidate>
				<div class="contact-form-grid">
					<label>
						<span>Nombre *</span>
						<input type="text" name="firstname" [(ngModel)]="formData.firstname" #firstname="ngModel"
							required autocomplete="given-name" />
					</label>

					<label>
						<span>Apellido *</span>
						<input type="text" name="lastname" [(ngModel)]="formData.lastname" #lastname="ngModel" required
							autocomplete="family-name" />
					</label>

					<label>
						<span>Teléfono *</span>
						<input type="tel" name="phone" [(ngModel)]="formData.phone" #phone="ngModel" required
							autocomplete="tel" pattern="^[0-9()+\s-]{6,25}$" />
					</label>

					<label>
						<span>E-mail *</span>
						<input type="email" name="email" [(ngModel)]="formData.email" #email="ngModel" required
							autocomplete="email" />
					</label>

					<div class="recaptcha-wrap">
						<re-captcha
						[siteKey]="recaptchaSiteKey"
						(resolved)="onRecaptchaResolved($event)"
						(expired)="onRecaptchaExpired()"
					></re-captcha>
					</div>
				</div>

				<p class="form-alert success" *ngIf="submitSuccessMessage">{{ submitSuccessMessage }}</p>
				<p class="form-alert error" *ngIf="submitErrorMessage">{{ submitErrorMessage }}</p>

				<div class="contact-actions">
					<button class="btn" type="submit" [disabled]="isSending">
						{{ isSending ? 'Enviando...' : 'Enviar' }}
					</button>
				</div>
			</form>
		</div>
	</div>
</section>